import { Button } from 'antd'
import React from 'react'

function GhostButton({children}) {
  return (
    <Button type='primary' ghost className='auf-button'>{children}</Button>
  )
}

export default GhostButton